import styled from "styled-components";

export const PlanDetailsEditModalWrapper = styled.form`
  overflow-y: auto;
  height: auto;

  background: var(--color-background);

  padding: var(--cardPadding);

  display: flex;
  flex-direction: column;

  gap: calc(var(--flexGap) / 2);

  border-radius: 1.5rem;

  width: min(100%);

  box-shadow:
    0 20px 50px rgba(0, 0, 0, 0.08),
    0 6px 18px rgba(0, 0, 0, 0.05);

  animation: modalEnter 0.22s ease;

  @keyframes modalEnter {
    from {
      opacity: 0;
      transform: translateY(8px) scale(0.98);
    }

    to {
      opacity: 1;
      transform: translateY(0px) scale(1);
    }
  }

  legend {
    font-family: Inter;

    font-weight: 700;

    font-size: 2rem;

    text-align: center;

    margin-bottom: 0.5rem;

    padding-inline: 0;

    color: #1a1c1c;
  }

  fieldset {
    flex: 1;

    border: none;

    display: flex;
    flex-direction: column;

    gap: 0.5rem;
  }

  .modal-header {
    margin-bottom: 1rem;
  }

  .modal-header > p {
    text-align: center;

    color: var(--color-text);

    line-height: 1.6;
  }

  .tab-navigation {
    display: flex;
    gap: 1rem;
    border-bottom: 2px solid #e0e0e0;
    margin-bottom: 1.5rem;
  }

  .tab-button {
    padding: 0.75rem 1.5rem;
    border: none;
    background: transparent;
    cursor: pointer;
    font-weight: 600;
    color: #999;
    border-bottom: 3px solid transparent;
    transition: all 0.2s ease;
    font-size: 0.95rem;

    &:hover {
      color: var(--color-primary);
    }

    &.active {
      color: var(--color-primary);
      border-bottom-color: var(--color-primary);
    }
  }

  .tab-content {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    min-height: auto;
  }

  .checkbox-group {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
  }

  .checkbox-fieldset {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.75rem;

    label {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      cursor: pointer;
      font-weight: 500;
      margin: 0;

      input[type="checkbox"] {
        width: 18px;
        height: 18px;
        cursor: pointer;
        margin: 0;
      }

      span {
        font-size: 0.95rem;
      }
    }
  }

  .features-list {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;

    fieldset {
      gap: 0.5rem;
    }
  }

  .feature-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding: 0.75rem 0.9rem;
    border: 1px solid #e4e4e4;
    border-radius: 0.75rem;
    background: #fcfcfd;
  }

  .feature-main {
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 0.5rem;
  }

  .feature-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .toggle-label {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
    font-weight: 600;
    margin: 0;

    input[type="checkbox"] {
      width: 18px;
      height: 18px;
      cursor: pointer;
      margin: 0;
    }
  }

  input {
    padding: 0.7rem 0.8rem;

    border-radius: 0.45rem;

    border: 1px solid var(--color-primary-hover);

    background-color: var(--color-button-secondary);

    font-weight: 500;

    transition: all 0.2s ease;

    outline: none;
  }

  input:focus {
    border-color: var(--color-primary);

    background-color: white;

    box-shadow: 0 0 0 3px rgba(3, 155, 229, 0.1);
  }

  .close-modal-button-area {
    position: absolute;
    top: 1rem;
    right: 1rem;
    z-index: 10;
  }

  .close-modal-button {
    padding: 0.5rem;
    border: none;
    background: transparent;
    cursor: pointer;
    font-size: 1.5rem;
    color: #999;
    transition: all 0.2s ease;

    &:hover {
      color: #333;
      transform: rotate(90deg);
    }
  }

  .submit-button-area {
    display: flex;
    gap: 1rem;
    justify-content: flex-end;
    margin-top: 1.5rem;
    padding-top: 1.5rem;
    border-top: 1px solid #e0e0e0;
    position: sticky;
    bottom: 0;
    background: var(--color-background);
    z-index: 10;

    button {
      padding: 0.75rem 1.5rem;
      border: none;
      border-radius: 0.45rem;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.2s ease;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.5rem;

      &:hover {
        opacity: 0.9;
      }
    }
  }

  @media (max-width: 768px) {
    padding: 1rem;
    max-height: none;

    legend {
      font-size: 1.5rem;
    }

    .tab-navigation {
      flex-wrap: wrap;
      gap: 0.5rem;
    }

    .tab-button {
      padding: 0.5rem 1rem;
      font-size: 0.85rem;
    }

    .submit-button-area {
      flex-direction: column;

      button {
        width: 100%;
      }
    }
  }
`;
